module.exports = __webpack_public_path__ + "img/preloaderRomashka.2b7538e.svg";